const categorizeStocks = (availableAssets) => {
    const aggressive = []
    const balanced = []
    const safe = []
  
    availableAssets.forEach(stock => {
      if (stock.symbol === 'BTC') return
  
      if (stock.yield > 7) {
        aggressive.push(stock)
      } else if (stock.yield >= 3 && stock.yield <= 7) {
        balanced.push(stock)
      } else {
        safe.push(stock)
      }
    })
  
    return { aggressive, balanced, safe }
  }
  
  export { categorizeStocks }